<template>
  <transition name="fade-grafico-mapa" mode="out-in">
    <div v-if="!loading">
      <unicom-linha :espacamento="false" style="min-height: 35px">
        <unicom-coluna sm="auto" alinhamento="center" class="mr-3">
          <unicom-icone style="color: #00995d" nome="pie-chart" :tamanho="25" />
        </unicom-coluna>
        <unicom-coluna sm="auto" alinhamento="center">
          <div class="negrito fonte-primaria" style="font-size: 21px">
            Prestadores por região
          </div>
        </unicom-coluna>
        <unicom-coluna
          sm="12"
          md="4"
          :class="$breakpoint.smAndDown ? 'mt-3' : ''"
          class="ml-auto"
          alinhamento="center"
        >
          <unicom-autocomplete
            :desativado="loadingGrafico"
            mostrarIconeExcluir
            colorPlaceholder="#9E9E9E"
            placeholder="Selecione um estado"
            v-model="estadoAutocomplete.descricao"
            @index="selecionarEstado"
            @limpar-campo="limparEstado"
            :items="listaEstados.map(e => e.descricao)"
          />
        </unicom-coluna>
      </unicom-linha>
      <highcharts
        id="container-mapa"
        :constructorType="'mapChart'"
        class="hc"
        :options="chartOptions"
        ref="mapa"
        :callback="mapaCarregadoCallback"
      ></highcharts>
    </div>
    <CarregandoMapa v-else />
  </transition>
</template>

<script>
/// Mixins
import EstadoMixin from "./Mixins/EstadoMixin";
import RegiaoMixin from "./Mixins/RegiaoMixin";
import GraficoMixin from "./Mixins/GraficoMapaMixin";

import Highchart from "highcharts";
import CarregandoMapa from "./CarregandoMapa";

import BrasilEstado from "./MapasGeoJson/BrasilEstado.json";

export default {
  components: {
    CarregandoMapa
  },
  mixins: [EstadoMixin, RegiaoMixin, GraficoMixin],
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    listaEstados: {
      type: Array,
      default: () => {
        return [];
      }
    },
    arrayGrafico: {
      type: Array
    },
    totalPrestadoresBase: {
      type: Number,
      default: 0
    },
    loadingGrafico: {
      type: Boolean,
      default: false
    },
    listaRegioes: {
      type: Array,
      default: () => []
    },
    totalPrestadoresEstado: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      isClickMapa: false,
      cores: ["#00663E", "#00995D", "#4ABB97", "#A4DDCB", "#D1EEE5"],
      iniciado: false,
      mudarPrototype: true,
      mapaCarregado: false,
      estadoMarcado: false,
      estadoAutocomplete: {
        chave: "",
        descricao: ""
      },
      graficoRef: null,
      dataEstados: [],
      dataRegioes: [],
      regiaoMarcada: false,
      regiaoClicada: null,
      funcoesTooltip: null
    };
  },
  watch: {
    arrayGrafico: {
      deep: true,
      immediate: true,
      handler() {
        if (!this.iniciado || this.graficoRef === null) return;

        this.atualizarDados();
      }
    },
    loadingGrafico() {
      if (this.loadingGrafico) {
        this.graficoRef.showLoading();
        return;
      }

      this.graficoRef.hideLoading();
    },
    loading() {
      if (this.loading) {
        this.limparVariaveis();
      }
    }
  },
  methods: {
    limparVariaveis() {
      this.desmarcarEstadoRegiao();
      this.desmarcarRegiao();
      this.ativarTooltip();
      this.limparAutocomplete();

      this.iniciado = false;
      this.estadoMarcado = false;
      this.graficoRef = null;
      this.regiaoClicada = null;
    },

    /// Init

    /**
     * Função que é chamada quando o mapa é carregado
     */
    mapaCarregadoCallback() {
      this.init();
    },

    /**
     * Função inicializadora
     */
    init() {
      this.mapaCarregado = true;
      this.$nextTick(() => {
        this.salvarMapaRef();
        this.atualizarDados();
        this.adicionarLegendaRegiao();

        this.salvarTooltipFuncoes();

        Highchart.wrap(Highchart.Point.prototype, "setState", function(
          proceed,
          state
        ) {
          if (this.properties && this.properties.codarea && state === undefined)
            return;

          proceed.apply(this, Array.prototype.slice.call(arguments, 1));
        });

        this.iniciado = true;
      });
    },

    /**
     * Salva o gráfico do mapa
     */
    salvarMapaRef() {
      this.graficoRef = this.$refs.mapa.chart;
    },

    /**
     * Atualiza os dados da região e estado, se necessário
     * atualiza as legendas
     */
    atualizarDados() {
      if (this.arrayGrafico.length === 0) return;

      this.dataEstados = [];
      this.dataRegioes = [];

      this.arrayGrafico.forEach((e, i) => {
        const { quantidade, tipo: chaveRegiao } = e;

        const descricaoRegiao = this.listaRegioes.find(
          e1 => e1.chave === chaveRegiao
        ).descricao;

        let pcnt = (quantidade / this.totalPrestadoresBase) * 100;

        const porcentagemFormatado = Highchart.numberFormat(pcnt, 2);

        this.dataRegioes.push({
          sigla: chaveRegiao,
          name: descricaoRegiao,
          value: quantidade,
          porcentagem: porcentagemFormatado
        });

        let estadosFiltradosPorRegiao = BrasilEstado.features.filter(
          e1 => e1.properties.regiao.sigla === chaveRegiao
        );

        estadosFiltradosPorRegiao.forEach(e2 => {
          const { nome, sigla } = e2.properties;
          let value = 0,
            porcentagem = 0;

          this.dataEstados.push({
            name: nome,
            sigla,
            color: this.cores[i],
            value,
            porcentagem
          });
        });
      });

      const series = this.graficoRef.series;

      series[0].update({ data: this.dataEstados }, false);
      series[1].update({ data: this.dataRegioes }, false);

      if (series.length > 2) {
        const legendas = series.slice(2);

        legendas.forEach((e, i) => {
          const { sigla: siglaLegenda } = e.options;

          const { value } = this.dataRegioes.find(
            e1 => e1.sigla === siglaLegenda
          );

          series[2 + i].data[0].update({ value }, false);
        });
      }

      this.graficoRef.redraw();
    },

    /**
     * Troca a visibilidade de alguma serie
     * @param { Number } numeroSerie
     * @param { Boolean } visivel
     */
    trocarVisibilidadeSerie(numeroSerie, visivel) {
      this.graficoRef.series[numeroSerie].update(
        {
          visible: visivel
        },
        false
      );

      this.graficoRef.redraw();
    },

    /// LEGENDA

    /**
     * Remove todas as legendas
     */
    removerLegendas() {
      let series_ids = [];
      for (let s of this.graficoRef.series) {
        if (s.options.id !== undefined) {
          series_ids.push(s.options.id);
        }
      }
      for (let id of series_ids) {
        this.graficoRef.get(id).remove();
      }
    },

    /**
     * Desativa todas as legendas das regiões menos a que foi clicada
     */
    desativarLegendaRegioes() {
      const arrayLegendas = this.graficoRef.series.slice(2);
      arrayLegendas.forEach(e => {
        if (e.points[0].sigla !== this.regiaoClicada) {
          e.update(
            {
              visible: false
            },
            false
          );
        }
      });

      this.graficoRef.redraw();
    },

    /**
     * Ativa todas as legendas das regiões
     */
    ativarLegendaRegioes() {
      const arrayLegendas = this.graficoRef.series.slice(2);
      arrayLegendas.forEach(e => {
        e.update(
          {
            visible: true
          },
          false
        );
      });

      this.graficoRef.redraw();
    },

    /// TOOLTIP

    /**
     * Salva as funções do tooltip.__proto__
     */
    salvarTooltipFuncoes() {
      if (this.funcoesTooltip !== null) return;

      const { refresh, hide } = this.graficoRef.tooltip.__proto__;

      this.funcoesTooltip = { refresh, hide };
    },

    /**
     * Ativa o tooltip
     */
    ativarTooltip() {
      this.graficoRef.tooltip.__proto__.refresh = this.funcoesTooltip.refresh;
      this.graficoRef.tooltip.__proto__.hide = this.funcoesTooltip.hide;
    },

    /**
     * Desativa o tooltip
     */
    desativarTooltip() {
      this.graficoRef.tooltip.__proto__.refresh = () => {};
      this.graficoRef.tooltip.__proto__.hide = () => {};
    },

    /**
     * Esconde o tooltip
     */
    esconderTooltip() {
      this.graficoRef.tooltip.hide();
    }
  }
};
</script>

<style lang="scss">
@import "./Mapa.scss";
</style>
